import { useMemo, useState } from "react";
import usePersistedState from "../../hooks/usePersistedState";
import useConversationsList from "./useConversationsList";
import { filterConversations, sortConversations } from "./filterAndSortConversations";
import ConversationFilters from "./ConversationFilters";
import ConversationTile from "./ConversationTile";

// The filters+tile-grid body of the conversation template list, extracted so
// it can be embedded both standalone (ConversationListView, /conversations-new)
// and inside the /conversations-menu dashboard.
export default function ConversationTemplatesSection() {
    // Dropdown filters persist (usePersistedState) - the whole point is
    // landing back on whatever the teacher last narrowed down to instead of
    // always resetting to "Forms" (type=3). `search` stays plain useState on
    // purpose: a leftover search term silently filtering a future visit
    // ("why is this list empty?") is a worse default than always starting
    // blank, unlike the dropdown filters which behave more like settings.
    const [conversationType, setConversationType] = usePersistedState("conversations-templates-type", 3);
    const [level, setLevel] = usePersistedState("conversations-templates-level", "");
    const [isPublic, setIsPublic] = usePersistedState("conversations-templates-ispublic", "");
    const [search, setSearch] = useState("");
    const [sort, setSort] = usePersistedState("conversations-templates-sort", "newest");

    const { conversations, conversationTypes, levels, usedConversationIds } = useConversationsList(conversationType);

    const visibleConversations = useMemo(() => {
        const filtered = filterConversations(conversations, { search, level, isPublic });
        return sortConversations(filtered, sort);
    }, [conversations, search, level, isPublic, sort]);

    return (
        <div>
            <ConversationFilters
                conversationType={conversationType}
                onConversationTypeChange={setConversationType}
                conversationTypes={conversationTypes}
                level={level}
                onLevelChange={setLevel}
                levels={levels}
                isPublic={isPublic}
                onIsPublicChange={setIsPublic}
                search={search}
                onSearchChange={setSearch}
                sort={sort}
                onSortChange={setSort}
            />
            <p className="conv-progress-list-count">Знайдено: {visibleConversations.length}</p>

            <div className="conversation-plate-container scrooll">
                {visibleConversations.map((conversation) => (
                    <ConversationTile
                        key={conversation.id}
                        conversation={conversation}
                        isUsed={usedConversationIds.has(conversation.id)}
                    />
                ))}
            </div>
        </div>
    );
}
